import { TableHeaderCell } from 'common/components';
import type { TableFilterOption } from '../CallsTable';

type StatusCellProps = {
    filterStatus: string;
    statusOptions: TableFilterOption[];
    onFilterStatus: (value: string) => void;
};

export const StatusCell = ({ filterStatus, statusOptions, onFilterStatus }: StatusCellProps) => {
    const options = [{ value: '', label: 'All statuses' }, ...statusOptions];

    return (
        <TableHeaderCell
            label='Status'
            isSearchable
            filterOptions={{
                options,
                selectedValue: filterStatus,
                onChange: onFilterStatus,
            }}
        />
    );
};
